<template>
    <div id="alarm">
        <div class="title">{{IncidentClassificationClass=='urgent'?'紧急':IncidentClassificationClass=='hiddenDanger'?"隐患":"通知"}}事件<i v-if="list.length!=0">({{list.length}})</i></div>
        <div class="page" v-if="!ishow">
            <div class="cont">
                <div class="header" :class="{yell:IncidentClassificationClass=='hiddenDanger',notice:IncidentClassificationClass=='notice'}">
                    <div class="type row-center" ><img src="@/assets/img/alarm.png" alt="">
                        <!-- <i v-if="eventList.incident_classification=='hiddenDanger'">隐患</i>
                            <i v-else-if="eventList.incident_classification=='notice'">通知</i>
                            <i v-else>紧急</i> -->
                            <i>{{ eventList.levelText }}</i></div>
                    <div class="name-r column-center">
                        <div class="left">
                            <div class="name u-line-1">{{eventList.eventName}}</div>
                            <div class="text">{{eventList.loopName}}</div>
                        </div>
                        <div class="time">{{dateTimeStamp(eventList.startTime)}}</div>
                    </div>
                </div>
                <div class="info">
                    <div class="description">
                        <div class="data-title">基本信息</div>
                        <div class="description-content">
                            <div>事件分类：{{eventList.eventClassText}}</div>
                            <div>站点信息：{{eventList.areaName}}</div>
                            <div>发生时间：{{eventList.startTime | dateFormat}} 
                                <div style="display: inline-block;margin-left:50px">结束时间：<span style="color:rgb(255, 85, 85)">未解决</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="description">
                        <div class="data-title">事件诊断</div>
                        <div class="description-content">
                            <div>告警原因：{{ eventList.loopName }}<i v-if="eventList.eventClassText=='操作命令'">{{eventList.operationUserName}}</i> {{eventList.alamReason}} <i v-if="eventList.eventClassText=='操作命令'">{{eventList.loopName}}</i></div>
                            <!-- <div>告警原因：{{eventList.alamReason}}</div> -->
                            <div>解决建议：{{eventList.suggest}}</div>
                            <!-- <div>告警数值：<i v-if="eventList.maxVal!=0&&eventList.maxVal!=1">{{eventList.maxVal}}{{eventList.unit}}</i><i class="grey" v-else>--</i></div> -->
                            <div>告警数值：<i v-if="eventList.judgmentMode=='Threshold_Value'">{{eventList.conditionJudgmentText}}</i><i v-if="eventList.judgmentMode=='Threshold_Value'">{{eventList.maxVal.toFixed(2)}} {{eventList.unit}}</i><i v-else >--</i></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="paging">
                <div class="divide">
                    <span class="pre" :class="{disabled:page<=1}"  @click.stop="prePage()">上一条</span>
                    <span class="num">{{page}}/{{list.length}}</span>
                    <span class="next" :class="{disabled:page==list.length}" @click.stop="nextPage()">下一条</span>
                </div>
                <span class="checkAll"  @click.stop="checkEvent">查看{{IncidentClassificationClass=='urgent'?'紧急':IncidentClassificationClass=='hiddenDanger'?"隐患":"通知"}}历史事件</span>
            </div>
        </div>
        <div v-if="ishow" class="nodata column-center">
            <div class="img"><img src="@/assets/img/nodata.png" alt=""></div>
            <div class="paging">
                <span class="checkAll" @click.stop="checkEvent">查看{{IncidentClassificationClass=='urgent'?'紧急':IncidentClassificationClass=='hiddenDanger'?"隐患":"通知"}}历史事件</span>
            </div> 
        </div>
    </div>
</template>
<script>
import { EventListPage } from "../../api/power";
import {dateFormat} from '../../util/DateUtil';
import dateTimeStamp from '../../util/DateDiff';
const TYPES = {
    fault: "故障报警",
    hiddenDanger: "隐患",
    messageNotice: "信息通报",
    notice: "通知",
    operation:"操作命令",
    other: "其他",
    overrun:"越限异常",
    protections:"保护动作",
    switchDisplacement:"开关变位",
    urgent:"紧急",
}
export default {
    components: { 
        
    },
    props:{
        IncidentClassificationClass:String
    },
    data () {
        return {
            // eventList:{},
            list:[],
            page:1,
            ishow:false
        }
    },
    computed: {
        dateTimeStamp() {
            return dateTimeStamp
        },
        eventList(){
            return this.list[this.page-1]
        }
    },
    watch:{
        IncidentClassificationClass(n,o){
            this.page = 1
            this.getEventList()
        },
        '$store.state.project.AlarmEvent'(n,o){
            if(n!=o){
                this.getEventList();
            }
        }
    },
    filters: {
        mapper: function (value) {
            return TYPES[value] || '未知事件';
        },
        dateFormat: function (value) {
            if (!value) {
                return '--';
            }
            return dateFormat('YYYY年mm月dd日 HH:MM', new Date(value));
        }
    },
    mounted(){
        this.page = 1
        this.getEventList();

    },
    methods: {
        checkEvent(){
            this.$emit("closed",true)
            this.$router.push({
                path:`/Home/WorkBench/EventManagement`,
                query:{
                    type:this.IncidentClassificationClass,
                },
            })
            // this.$router.push("/Home/WorkBench/EventManagement");
            this.$store.commit("setCurrWorkBench",'/Home/WorkBench/EventManagement')    
        },
        prePage(){
            if(this.page<=1){
                this.page = 1
                return 
            }
            this.page--
            // this.getEventList()
        },
        nextPage(){
            this.page++
            if(this.page==this.list.length){
                this.page = this.list.length
                return 
            }
            // this.getEventList()
        },
        async getEventList(){
            let result = await EventListPage({
                projectId: this.$store.getters.projectId,
                page:this.page,
                size:1000,
                incidentClassificationClass:this.IncidentClassificationClass,
                solveFlag:0
            });
            let data = result.data.data.eventList
            if(data.records.length>0){
                this.list = data.records.filter(e=>{if(!e.endTime)return e})
                console.log(this.list,"this.list")
                this.ishow = false
            }else{
                this.ishow = true
                this.list = []
            }
        },
    }
}
</script>

<style scoped lang="less">
    .nodata{
        text-align: center;
        // padding-top: 5vh;
        height: 100%;
        justify-content: space-evenly;
    }
    #alarm{
        position: fixed;
        width: 592px;
        height: 480px;
        background: #FFFFFF;
        box-shadow: 0px 0px 68px 0px rgba(0,43,102,0.24);
        border-radius: 4px;
        right: 24rem;
        top: 5.9vh;
        z-index: 99;
        .title{
            height: 36rem;
            line-height: 36rem;
            padding: 0 11rem;
            font-size: 16rem;
            font-weight: bold;
            color: #666666;
            border-bottom: 1px solid rgba(51, 51, 51, 0.08);
        }
        .page{
            padding: 10px;
        }
        .paging{
            text-align: center;
            .divide{
                display: inline-block;
                font-size: 16rem;
                color: #666666;
                padding: 20px 0;
                .next,.pre{
                    width: 84rem;
                    height: 40rem;
                    line-height: 40rem;
                    background: #FFFFFF;
                    border: 1px solid #CCCCCC;
                    border-radius: 4rem;
                    text-align: center;
                    display: inline-block;
                    cursor: pointer;
                }
                
                .disabled{
                    border: 1px solid #ffffff;
                    color: #CCCCCC;
                    cursor:no-drop;
                }
                .num{
                    padding: 0 20rem;
                }
            }
            
            .checkAll{
                height: 32px;
                line-height: 32px;
                background: #0D94FF;
                border-radius: 2px;
                width: 140px;
                color: #ffffff;
                font-size: 14px;
                display: inline-block;
                text-align: center;
                margin-left: 10%;
                cursor: pointer;
            }
        }
        .cont{
            border: 1px solid #CCCCCC;
            border-radius: 4px;
            height: 355px;
            .header{
                overflow: hidden;
                .type{
                    width: 52px;
                    height: 52px;
                    background: #F23F36;
                    border-radius: 4px;
                    color: #ffffff;
                    font-size: 14px;
                    font-weight: bold;
                    text-align: center;
                    padding: 5px 0;
                    float: left;
                    img{
                        display: inline-block;
                        width:20px;
                    }
                    i{
                        display: block;
                        width: 100%;
                    }
                }
                
                .name-r{
                    width: 510px;
                    height: 52px;
                    background: rgba(242, 63, 54, 0.1);
                    border-radius: 4px;
                    float: right;
                    padding: 2px 30px 0 20px;
                    align-content: space-between;
                    .left{
                        width: 80%;
                        height: 100%;
                    }
                    .name{
                        font-size: 18px;
                        font-weight: bold;
                    }
                    .text{
                        font-size: 14px;
                        font-weight: 400;
                        color: #666666;
                    }
                    .time{
                        font-size: 14px;
                        font-weight: 400;
                        color: #666666;
                    }
                }
            }
            .yell{
                .type{
                    background: #F6BD16;
                }
                .name-r{
                    background: rgba(246, 189, 22, 0.1);
                }
            }
            .notice{
                .type{
                    background: #0D94FF;
                }
                .name-r{
                    background: rgba(13, 148, 255, 0.1);
                }
            }
            .info{
                padding:0 20px;
                height: calc(100% - 52px);
                overflow: auto;
                .description {
                    margin-top: 20px;
                    .data-title{
                        font-size: 16rem;
                        // font-weight: bold;
                        line-height: 19px;
                        margin: 5px 0;
                        &::before{
                            content: '';
                            width: 4px;
                            height: 19rem;
                            background: #0D94FF;  
                            display: inline-block;
                            vertical-align: -2px;
                            margin-right: 8px;
                        }
                    }
                    .description-content {
                        display: flex;
                        flex-flow: column nowrap;

                        div {
                            font-size: 16rem;
                            font-weight: 400;
                            line-height: 30px;
                            padding-left: 12px;
                            // color: #666666;
                            // margin-bottom: 14rem;
                        }
                    }
                }
            }
        }
    }
</style>